var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStarSolid1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 50,
    viewBox: "0 0 56 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3255_11526)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.8097 1.75781C30.2944 0.683594 29.2056 0 28.0097 0C26.8139 0 25.7347 0.683594 25.2097 1.75781L18.9583 14.6777L4.99722 16.748C3.83056 16.9238 2.85833 17.7441 2.49861 18.8672C2.13889 19.9902 2.43056 21.2305 3.26667 22.0605L13.3972 32.1289L11.0056 46.3574C10.8111 47.5293 11.2972 48.7207 12.2597 49.4141C13.2222 50.1074 14.4958 50.1953 15.5458 49.6387L28.0194 42.9492L40.4931 49.6387C41.5431 50.1953 42.8167 50.1172 43.7792 49.4141C44.7417 48.7109 45.2278 47.5293 45.0333 46.3574L42.6319 32.1289L52.7625 22.0605C53.5986 21.2305 53.9 19.9902 53.5306 18.8672C53.1611 17.7441 52.1986 16.9238 51.0319 16.748L37.0611 14.6777L30.8097 1.75781Z",
    fill: "#8DAF61"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3255_11526"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 50,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarSolid1);
export default __webpack_public_path__ + "static/media/star-solid 1.c278e7fcf961f804341db2e80309e7ee.svg";
export { ForwardRef as ReactComponent };